<template>
	<codeEditor
		:value="code"
		:lang="safeLanguage"
		:theme="safeTheme"
		:width="width"
		:height="height"
		:options="{'readOnly': readonly, 'autoScrollEditorIntoView': true}"
		id="editor"
		@input="$emit('input', $event)"
		@init="editorInit($event)">
	</codeEditor>
</template>

<script>
export default {
	components: {
		codeEditor: require('vue2-ace-editor')
	},
	props: [
		'code',
		'language',
		'theme',
		'width',
		'height',
		'readonly',
		'search',
		'scroll_to_line'
	],
	data () {
		return {
			editor: null,
			themes: [
				'ambiance',
				'chaos',
				'chrome',
				'clouds',
				'clouds_midnight',
				'cobalt',
				'crimson_editor',
				'dawn',
				'dracula',
				'dreamweaver',
				'eclipse',
				'github',
				'gob',
				'gruvbox',
				'idle_fingers',
				'iplastic',
				'katzenmilch',
				'kr_theme',
				'kuroir',
				'merbivore',
				'merbivore_soft',
				'monokai',
				'mono_industrial',
				'pastel_on_dark',
				'solarized_dark',
				'solarized_light',
				'sqlserver',
				'terminal',
				'textmate',
				'tomorrow',
				'tomorrow_night',
				'tomorrow_night_blue',
				'tomorrow_night_bright',
				'tomorrow_night_eighties',
				'twilight',
				'vibrant_ink',
				'xcode'
			],
			languages: [
				'abap',
				'abc',
				'actionscript',
				'ada',
				'apache_conf',
				'applescript',
				'asciidoc',
				'assembly_x86',
				'autohotkey',
				'batchfile',
				'bro',
				'c9search',
				'cirru',
				'clojure',
				'cobol',
				'coffee',
				'coldfusion',
				'csharp',
				'csound_document',
				'csound_orchestra',
				'csound_score',
				'css',
				'curly',
				'c_cpp',
				'd',
				'dart',
				'diff',
				'django',
				'dockerfile',
				'dot',
				'drools',
				'eiffel',
				'ejs',
				'elixir',
				'elm',
				'erlang',
				'forth',
				'fortran',
				'ftl',
				'gcode',
				'gherkin',
				'gitignore',
				'glsl',
				'gobstones',
				'golang',
				'graphqlschema',
				'groovy',
				'haml',
				'handlebars',
				'haskell',
				'haskell_cabal',
				'haxe',
				'hjson',
				'html',
				'html_elixir',
				'html_ruby',
				'ini',
				'io',
				'jack',
				'jade',
				'java',
				'javascript',
				'json',
				'jsoniq',
				'jsp',
				'jssm',
				'jsx',
				'julia',
				'kotlin',
				'latex',
				'lean',
				'less',
				'liquid',
				'lisp',
				'livescript',
				'live_script',
				'logiql',
				'lsl',
				'lua',
				'luapage',
				'lucene',
				'makefile',
				'markdown',
				'mask',
				'matlab',
				'mavens_mate_log',
				'maze',
				'mel',
				'mipsassembler',
				'mips_assembler',
				'mushcode',
				'mysql',
				'nix',
				'nsis',
				'objectivec',
				'ocaml',
				'pascal',
				'perl',
				'pgsql',
				'php',
				'pig',
				'plain_text',
				'powershell',
				'praat',
				'prolog',
				'properties',
				'protobuf',
				'python',
				'r',
				'razor',
				'rdoc',
				'red',
				'rhtml',
				'rst',
				'ruby',
				'rust',
				'sass',
				'scad',
				'scala',
				'scheme',
				'scss',
				'sh',
				'sjs',
				'smarty',
				'snippets',
				'soy_template',
				'space',
				'sparql',
				'sql',
				'sqlserver',
				'stylus',
				'svg',
				'swift',
				'swig',
				'tcl',
				'tex',
				'text',
				'textile',
				'toml',
				'tsx',
				'turtle',
				'twig',
				'typescript',
				'vala',
				'vbscript',
				'velocity',
				'verilog',
				'vhdl',
				'wollok',
				'xml',
				'xquery',
				'yaml'
			]
		}
	},
	computed: {
		safeLanguage () {
			if (this.language) {
				if (this.languages.indexOf(this.language) > -1) {
					return this.language
				}
			}
			return 'json'
		},
		safeTheme () {
			if (this.theme) {
				if (this.themes.indexOf(this.theme) > -1) {
					return this.theme
				}
			}
			return 'monokai'
		}
	},
	watch: {
		safeLanguage (language) {
			require(`brace/mode/${language}`)
			require(`brace/snippets/${language}`)
		},
		safeTheme (theme) {
			require(`brace/theme/${theme}`)
		}
	},
	methods: {
		editorInit: function (evt) {
			this.editor = evt
			// document.getElementById('editor').style.fontSize = '14px'
			this.editor.on('blur', () => {
				this.$emit('blur')
			})
			require('brace/ext/language_tools')
			require(`brace/mode/${this.safeLanguage}`)
			require(`brace/theme/${this.safeTheme}`)
			require(`brace/snippets/${this.safeLanguage}`)
			require('brace/ext/beautify')
			if (this.search) {
				require('brace/ext/searchbox')
				this.editor.execCommand('find')
				this.$nextTick(() => {
					this.editor.searchBox.show(
						this.search.trim().split(' ').join('|')
					)
					document.querySelector(
						'.ace_button[action="toggleRegexpMode"]'
					).click()
				})
			}
			if (this.scroll_to_line) {
				this.editor.resize(true)
				this.$nextTick(() => {
					this.editor.renderer.scrollToLine(this.scroll_to_line)
				})
			}
		}
	}
}
</script>

<style scoped lang="stylus">
.ace_editor.ace-monokai.ace_dark
	// font-size: 1.1em
	background-color: var(--v-background-darken1)
	>>>.ace_gutter
		background-color: var(--v-background-darken2)
		>>>.ace_gutter-cell
			padding-right: 20px !important
		.ace_fold-widget
			transform: scale(1.5) !important
	>>>.ace_selected-word
		border: 1px solid #ffe800

>>>.ace_search
>>>.ace_search_field
>>>.ace_searchbtn
	border-color: var(--v-background-lighten3)
	color: white

>>>.ace_search
>>>.ace_search_options > *
	color: white
	background-color: var(--v-background-base)

>>>.ace_searchbtn_close
	background-color: white

>>>.ace_search_form
>>>.ace_replace_form
	*
		background-color: var(--v-background-darken1)

::-webkit-scrollbar
::-webkit-scrollbar-track-piece
	background-color: var(--v-background-darken1) !important

>>>.ace_selected-word
>>>.ace_selection
	border: 1px solid var(--v-primary-base) !important
	background: black !important
>>>.ace_selection
	border: 2px solid var(--v-primary-base) !important
</style>



// WEBPACK FOOTER //
// src/components/ace_editor.vue